// extracted by mini-css-extract-plugin
module.exports = {"input":"HoursInput_input__2GgX5","updated":"HoursInput_updated__2N6oi"};